import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { initiateNewRound } from "../../redux/reducers/RoundReducer";
import { updateMode } from "../../redux/reducers/ModeReducer";
import ContentContainer from "../../components/ContentContainerComp/ContentContainer";
import medal1 from "../../assets/images/others/medal1.png";
import medal2 from "../../assets/images/others/medal2.png";
import medal3 from "../../assets/images/others/medal3.png";
import medalUser from "../../assets/images/others/medalUser.png";
import medalUser2 from "../../assets/images/others/medalUser2.png";
import coin from "../../assets/images/others/coin.png";
import s from "./style.module.css";

const LeaderboardContainer = () => {
  const allScoreRedux = useSelector((state) => state.allScore);
  const userInfo = useSelector((state) => state.UserInfo);
  const dispatch = useDispatch();

  const test = () => {
    const newArr = [];
    for (let i = 0; i < allScoreRedux.otherScore.length; i++) {
      newArr.push(allScoreRedux.otherScore[i].score);
    }
    return newArr;
  };
  const test2 = () => {
    const allArr = test();
    const convertArr = [];
    const userScore = allScoreRedux.userScore;
    for (let i = 0; i < allArr.length; i++) {
      convertArr.push(parseInt(allArr[i], 10));
    }
    convertArr.push(userScore);
    const unique = convertArr.filter((v, i, a) => a.indexOf(v) === i);
    const ascending = unique.sort((a, b) => b - a);
    return ascending.slice(0, 3);
  };

  return (
    <ContentContainer
      leaderBoard
      typeHeader={2}
      onCenter
      textHeader="ลำดับคะแนน"
      textHeaderColor="#ffffff"
      disableNext={1}
      disableBack={1}
      onPressNext={() => {
        dispatch(updateMode({ mode: 1, step: 6 }));
        dispatch(initiateNewRound());
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "20px",
        }}
      >
        {test2().map((item, idx) => (
          <div className={s.container}>
            <img
              src={idx + 1 === 1 ? medal1 : idx + 1 === 2 ? medal2 : medal3}
              alt="medal"
            />
            <div className={s.scoreWrapper}>
              <img
                style={{ width: "30%", height: "55%" }}
                src={coin}
                alt="coin"
              />
              <span>{Math.round(item)}</span>
            </div>
          </div>
        ))}
        {/* {allScoreRedux.otherScore.map((item, idx) => (
          <div className={s.container}>
            <img
              src={idx + 1 === 1 ? medal1 : idx + 1 === 2 ? medal2 : medal3}
              alt="medal"
            />
            <div className={s.scoreWrapper}>
              <img
                style={{ width: "30%", height: "55%" }}
                src={coin}
                alt="coin"
              />
              <span>{Math.round(item.score)}</span>
            </div>
          </div>
        ))} */}
        <div className={s.container}>
          <img
            className={s.imgMedalUser}
            src={userInfo.character === 1 ? medalUser : medalUser2}
            alt="medal"
          />
          <div className={s.scoreWrapper}>
            <img
              style={{ width: "30%", height: "55%" }}
              src={coin}
              alt="coin"
            />
            <span>{Math.round(allScoreRedux.userScore)}</span>
          </div>
        </div>
      </div>
    </ContentContainer>
  );
};

export default LeaderboardContainer;
